import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "locationDisplay", "locationEdit", "locationInput", "locationValue", "locationText"]

  connect() {
    // Close location edit when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }

  onFormSubmit(event) {
    // Hide the initial search content immediately when form is submitted
    const initialSearchContent = document.getElementById('initial-search-content')
    if (initialSearchContent) {
      initialSearchContent.style.display = 'none'
    }
    
    // Show search results container and loading spinner
    const searchResults = document.getElementById('search-results')
    if (searchResults) {
      searchResults.classList.remove('hidden')
      searchResults.innerHTML = `
        <div class="flex flex-col items-center justify-center pt-8 pb-0 px-0 w-full h-full">
          <div class="flex flex-col items-start justify-center max-w-[475px] w-full">
            <div class="flex flex-col items-start gap-0 w-full">
              <p class="text-xs font-medium leading-[1.5] text-support-dark-600 mb-0">
                Assistant
              </p>
              <div class="flex gap-[3px] items-center pl-0 pr-4 py-1 rounded">
                <div class="relative shrink-0 size-6">
                  <svg class="animate-spin h-6 w-6 text-core-purple-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
                <p class="text-sm leading-[1.5] text-support-dark-400">
                  Thinking...
                </p>
              </div>
            </div>
          </div>
        </div>
      `
    }
    // Form submission handled by Rails
  }

  // Location management methods
  toggleLocationEdit(event) {
    event.stopPropagation()
    this.locationDisplayTarget.classList.add('hidden')
    this.locationEditTarget.classList.remove('hidden')
    this.locationInputTarget.focus()
    this.locationInputTarget.select()
  }

  saveLocation() {
    const newLocation = this.locationInputTarget.value.trim()
    if (newLocation) {
      this.locationTextTarget.textContent = newLocation
      this.locationValueTarget.value = newLocation
    }
    this.cancelLocationEdit()
  }

  cancelLocationEdit() {
    this.locationEditTarget.classList.add('hidden')
    this.locationDisplayTarget.classList.remove('hidden')
    // Reset input to current displayed value
    this.locationInputTarget.value = this.locationTextTarget.textContent
  }

  // Handle keyboard events in location input
  handleLocationKeyup(event) {
    if (event.key === 'Enter') {
      this.saveLocation()
    } else if (event.key === 'Escape') {
      this.cancelLocationEdit()
    }
  }

  // Click outside to hide location edit
  handleOutsideClick(event) {
    if (!this.hasLocationEditTarget) return

    if (!this.locationEditTarget.classList.contains('hidden') &&
      !this.locationEditTarget.contains(event.target) &&
      !this.locationDisplayTarget.contains(event.target)) {
      this.cancelLocationEdit()
    }
  }

  selectSuggestedSearch(event) {
    const query = event.currentTarget.dataset.searchQuery
    if (query) {
      this.inputTarget.value = query
      // Find the form (it's a sibling of the controller element)
      const form = this.element.querySelector('form')
      if (form) {
        form.requestSubmit()
      }
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }
}
